import Vue from 'vue'
import BasicModel from '@/framework/basic/BasicModel'
import Config from '@/framework/configs/Config'
import lrz from 'lrz'
Vue.directive('form', {
  inserted: function (el, binding, vnode) {
    let _this = vnode.context
    let componentInstance = vnode.componentInstance
    let form = componentInstance.model
    let fromName = binding.name

    if (form) {
      let id = form.id

      let context = {}
      context._this = _this
      context.fromName = fromName
      context.id = id
      context.form = form
      context.map = new Map()
      context.formComponentInstance = componentInstance

      let selectAction = componentInstance.$attrs.selectAction
      if (selectAction && id) {
        selectInfo(context, selectAction, form)
      }

      // 自动寻找组件中的提交按钮
      loadComponents(context, componentInstance)
    }
  }
})

function findUpload (obj) {
  let childrens = obj.$children
  for (let i = childrens.length; i > 0; i--) {
    let children = childrens[i - 1]
    if (children.$options._componentTag === 'el-upload') {
      return children
    } else {
      if (children.$children && children.$children.length > 0) {
        let obj = findUpload(children)
        if (obj) {
          return obj
        }
      }
    }
  }
}

function loadComponents (context, componentInstance) {
  let childrens = componentInstance.$children
  for (let i = childrens.length; i > 0; i--) {
    let children = childrens[i - 1]

    // 保存字段名称和类型
    let tagName = children.$options._componentTag

    let model = children.$vnode.data.model
    if (model && model.expression) {
      let array = model.expression.split('.')
      if (array && array[1]) {
        context.map.set(array[1], tagName)
        context.map.set(array[1] + 'component', children)
      }
    }
    if ((tagName === 'el-button' && children.$options.propsData.type === 'primary') || (tagName === 'el-button' && children.$el.attributes.hasOwnProperty('submit'))) {
      handleSubmit(context, children)
    } else if (tagName === 'el-upload') {
      handleUpload(context, children)
    } else {
      if (children.$children && children.$children.length > 0) {
        loadComponents(context, children)
      }
    }
  }
}
function handleUpload (context, upload) {
  upload.onRemove = function (file, i) {
    let array = upload.$vnode.data.model.expression.split('.')
    context._this.$set(context.form, array[1], i)
    context._this.$set(context, 'delFiles', context.delFiles ? (context.delFiles + ',' + file.name) : file.name)
  }

  upload.onSuccess = function (response, file, fileList) {
    if (!upload.$vnode.data.model) {
      console.log('没有设置v-model哦！')
      return
    }

    let array = upload.$vnode.data.model.expression.split('.')
    for (let i = 0; i < fileList.length; i++) {
      var item = fileList[i]
      if (item.uid === file.uid) {
        fileList.splice(i, 1)
        continue
      }
    }
    let images = fileList

    let baseImageUrl = Config.imageUrl

    let image = {
      name: response.datas ? response.datas[0] : response.name,
      url: baseImageUrl + (response.datas ? response.datas[0] : response.name)
    }

    if (images && upload.multiple) {
      images.push(image)
    } else {
      images = image
    }

    context._this.$set(context.form, array[1], images)
  }
}

function handleSubmit (context, submitButton) {
  let objEl = submitButton.$el
  objEl.onclick = function () {
    context.formComponentInstance.validate((valid) => {
      if (valid) {
        if (!context.form.id) {
          add(context, context.formComponentInstance, context.fromName)
        } else {
          edit(context, context.formComponentInstance, context.fromName)
        }
      } else {
        window.scrollBy(0, -10)
        return false
      }
    })
  }
}

function resetComponents (context, componentInstance) {
  let childrens = componentInstance.$children
  for (let i = childrens.length; i > 0; i--) {
    let children = childrens[i - 1]

    if (children.clear) {
      children.clear()
    }

    if (children.$options._componentTag === 'el-upload') {
      children.clearFiles()
    } else {
      if (children.$children && children.$children.length > 0) {
        resetComponents(context, children)
      }
    }
  }
}

// 执行网络操作
function selectInfo (context, selectAction, form) {
  let _this = context._this
  let params = {
    id: form.id
  }
  let listener = {
    success: function (dataInfo) {
      for (var variable in dataInfo.datas) {
        if (dataInfo.datas.hasOwnProperty(variable)) {
          let data = dataInfo.datas[variable]
          let dataCls = Object.prototype.toString.apply(data)

          let formData = form[variable]
          let formCls = Object.prototype.toString.apply(formData)
          switch (formCls) {
            case '[object Array]':
              if (dataCls === '[object String]') {
                if (context.map.get(variable) === 'el-upload') {
                  let baseImageUrl = Config.imageUrl
                  let icons = dataInfo.datas[variable].split(',')
                  let newIcons = []
                  for (var i = 0; i < icons.length; i++) {
                    let icon = icons[i]
                    if (!icon) {
                      continue
                    }

                    let name = icon.replace(baseImageUrl, '')

                    let newIcon = baseImageUrl + name
                    newIcons.push({
                      name: name,
                      url: newIcon
                    })
                  }

                  _this.$set(form, variable, newIcons)
                } else {
                  if (!data) {
                    continue
                  }
                  let newData = data.split(',')
                  _this.$set(form, variable, newData)
                }
              }
              break
            default:

              if (context.map.get(variable) === 'el-upload') {
                var baseImageUrl = Config.imageUrl

                if (data instanceof Array) {
                  let showList = []
                  for (let i = 0; i < data.length; i++) {
                    let item = data[i]
                    let name = item.replace(baseImageUrl, '')
                    let newIcon = baseImageUrl + name
                    showList.push({ name: name, url: newIcon })
                  }
                  _this.$set(form, variable, showList)
                } else {
                  let name = data.replace(baseImageUrl, '')
                  let newIcon = baseImageUrl + name
                  _this.$set(form, variable, { name: name, url: newIcon })
                }
              } else {
                _this.$set(form, variable, data)
              }
          }
        }
      }

      if (_this.onSelectInfo) {
        _this.onSelectInfo(dataInfo)
      }
    }
  }
  BasicModel.get(_this, selectAction, params, listener)
}

function add (context, formComponentInstance, formName) {
  let loading = context._this.$loading({
    lock: true,
    text: '正在提交中,请稍等...',
    spinner: 'el-icon-loading',
    background: 'rgba(0, 0, 0, 0.7)'
  })
  let addAction = formComponentInstance.$attrs.addAction
  if (addAction) {
    let listener = {
      success: function (dataInfo) {
        loading.close()
        if (formComponentInstance.$listeners.onAdded) {
          let isEnd = formComponentInstance.$listeners.onAdded(dataInfo)
          if (isEnd) {
            return
          }
        } else if (context._this.onAdded) {
          context._this.onAdded(dataInfo)
        } else {
          context._this.$router.go(-1)
          context._this.$message({
            type: 'success',
            message: '提交成功!'
          })
        }
        deleteAliyunObject(context)
        formComponentInstance.resetFields()
        resetComponents(context, formComponentInstance)
      },
      error: function (response) {
        loading.close()

        context._this.$message.error(response.body.errMsg)
      }
    }

    let model = formComponentInstance.model

    let params = {}

    filterParams(context, params, model)

    BasicModel.post(context._this, addAction, params, listener)
  }
}

function edit (context, formComponentInstance, formName) {
  let loading = context._this.$loading({
    lock: true,
    text: '正在提交中,请稍等...',
    spinner: 'el-icon-loading',
    background: 'rgba(0, 0, 0, 0.7)'
  })

  let editAction = formComponentInstance.$attrs.editAction
  if (editAction) {
    let listener = {
      success: function (dataInfo) {
        loading.close()

        if (formComponentInstance.$listeners.onEdited) {
          let isEnd = formComponentInstance.$listeners.onEdited(dataInfo)
          if (isEnd) {
            return
          }
        } else if (context._this.onEdited) {
          context._this.onEdited(dataInfo)
        } else {
          context._this.$router.go(-1)
          context._this.$message({
            type: 'success',
            message: '提交成功!'
          })
        }
        deleteAliyunObject(context)
        formComponentInstance.resetFields()
        resetComponents(context, formComponentInstance)
      },
      error: function (response) {
        loading.close()

        context._this.$message.error(response.body.errMsg)
      }
    }

    let model = formComponentInstance.model

    let params = {}

    filterParams(context, params, model)

    BasicModel.post(context._this, editAction, params, listener)
  }
}

// 过滤参数
function filterParams (context, params, model) {
  for (var fieldName in model) {
    let viewType = context.map.get(fieldName)
    let fieldData = model[fieldName]
    if (fieldData == null) {
      continue
    }

    let className = Object.prototype.toString.apply(fieldData)

    if (className === '[object Array]') {
      if (viewType === 'el-upload') {
        let componentView = context.map.get(fieldName + 'component')

        let newData = []
        for (var j = 0; j < fieldData.length; j++) {
          let data = fieldData[j]
          if (componentView.$attrs.hasOwnProperty('full')) {
            newData.push(data.url)
          } else {
            newData.push(data.name)
          }
        }
        params[fieldName] = newData.join(',')
      } else {
        params[fieldName] = model[fieldName].join(',')
      }
    } else if (className === '[object Object]') {
      if (viewType === 'el-upload') {
        let componentView = context.map.get(fieldName + 'component')
        if (componentView.$attrs.hasOwnProperty('full')) {
          params[fieldName] = fieldData.url
        } else {
          params[fieldName] = fieldData.name
        }
      }
    } else if (className === '[object Date]') {
      params[fieldName] = model[fieldName].getTime()
    } else {
      params[fieldName] = model[fieldName]
    }
  }

  if (context._this.onFilterParams) {
    context._this.onFilterParams(params)
  }
}

function deleteAliyunObject (context) {
  let listener = {
    success: function (dataInfo) {

    },
    error: function (response) {

    }
  }

  if (context.delFiles) {
    BasicModel.post(context._this, 'upload/deletePic.action', { 'fileNamePath': context.delFiles }, listener)
  }
}
